var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',[_vm._v("\n  "+_vm._s(_vm.displayDate)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }